/**
 * 404 Not Found 컴포넌트
 *
 * 라우트가 존재하지 않거나, 권한이 없어 접근이 거부된 경우 표시한다.
 * 권한 거부 시에도 의도적으로 404를 표시하여 페이지 존재 여부 자체를 숨긴다.
 */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Result, Button } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import useLanguage from '../../hooks/useLanguage';

const TEXTS = {
  ko: {
    title: '404',
    subTitle: '요청하신 페이지를 찾을 수 없습니다.',
    goHome: '홈으로',
  },
  en: {
    title: '404',
    subTitle: 'Sorry, the page you visited does not exist.',
    goHome: 'Home',
  },
};

/**
 * 404 페이지
 * @param {Object} props
 * @param {string} [props.subTitle] - 커스텀 부제목 (선택)
 */
function NotFound({ subTitle }) {
  const { t } = useLanguage(TEXTS);
  const history = useHistory();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 400,
        padding: '40px 16px',
      }}
    >
      <Result
        status="404"
        title={t.title}
        subTitle={subTitle || t.subTitle}
        extra={
          <Button
            type="primary"
            icon={<HomeOutlined />}
            onClick={() => history.push('/')}
          >
            {t.goHome}
          </Button>
        }
      />
    </div>
  );
}

export default NotFound;
